module.exports = __webpack_public_path__ + "img/189.3b1a276f.jpg";